module.exports = __webpack_public_path__ + "img/00045.30b22626.webp";